import React from 'react';
import classNames from 'classnames/bind';
import styles from './AdviceRequest.scss';

const cx = classNames.bind(styles);

const AdviceRequest = ({ handleClose }) => {
  return (
    <div className={cx('AdviceRequest')}>
      <div className="close" onClick={handleClose}></div>
      <div className="advice-content">
        <h3>
          지금 전화 상담을 신청하시면
          <br />
          7일 동안 무료로 체험해 볼 수 있어요!
        </h3>
        <input
          type="text"
          className="form-input"
          name="txtName"
          placeholder="신청자 이름"
        />
        <input
          type="text"
          className="form-input"
          name="txtPhone"
          placeholder="전화번호"
        />
        <div className="check-box">
          <label>
            <input type="checkbox" name="chk" className="form-chk" />
            <span>
              오케이 닥터 상담 신청을 위한
              <br />
              <span className="form-privacy">개인정보 수집 및 이용</span>에
              동의합니다.
            </span>
          </label>
        </div>
        <button className="btn-advice">신청하기</button>
      </div>
    </div>
  );
};

export default AdviceRequest;
